import {merge} from 'mojito/utils';

import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {generateRunnerInfo} from '#core/application/modules/tiles/runner-info/index.js';
import {generateStreamingIndicator} from '#core/application/modules/tiles/streaming-indicator/index.js';
import {generateBorder} from '#core/application/modules/tiles/border/index.js';
import {generateOddsButton} from '#core/application/modules/tiles/odds-button/index.js';

export function raceCardsFactory(PALETTE) {
    return {
        RaceCardPreview: {
            eventCardBase: {
                container: {
                    style: {
                        height: 'initial', // for RaceCardPreview height must be dynamic (I think)
                    },
                },
                clickableArea: {
                    style: {
                        base: {
                            minHeight: 32,
                        },
                    },
                },
                title: {
                    style: {
                        ...PALETTE.CARD_RACE_EVENT_NAME_TEXT,
                    },
                },
            },
            showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
            runnerInfo: merge(generateRunnerInfo(PALETTE.CARD_RUNNER_INFO), {
                selectionButton: generateOddsButton(PALETTE.EVENT_CARDS_ODDS_BUTTON),
            }),
            raceNameLabel: {
                style: PALETTE.CARD_RACE_INFO_TEXT,
            },
            racingSportIcon: {
                style: {
                    fill: PALETTE.CARD_SPORT_ICON_COLOR,
                    minWidth: 12,
                },
            },
            raceDistanceLabel: {
                style: PALETTE.CARD_RACE_INFO_TEXT,
            },
            showAllLabel: {
                container: {
                    flexShrink: 0,
                },
                style: PALETTE.CARD_SHOW_ALL_LINK.SECONDARY_LINK_TEXT,
            },
            showAllIcon: {
                style: {
                    fill: PALETTE.CARD_SHOW_ALL_LINK.SECONDARY_LINK_ICON_COLOR,
                },
            },
            streamingIndicator: generateStreamingIndicator(PALETTE.CARD_STREAMING_INDICATOR),
            bestOddsIcon: icon(PALETTE.CARD_RACE_ICON_COLOR),
            enhancedEachWayTermsIcon: icon(PALETTE.CARD_RACE_ICON_COLOR),
        },
        RaceCardsSkeleton: {
            raceCardContainer: {
                style: {
                    ...resolveBackground(PALETTE.PARENT.CARD_CONTAINER_BG),
                    ...generateBorder(PALETTE.PARENT.CARD_BORDER),
                },
            },
        },
    };
}
